<div>
  <component-formulas
          [serviceId]="serviceId"
          [componentKey]="componentKey"
          [componentFormulaId]="componentFormulaId"
          [determinantMapById]="determinantMapById"
          [costView]="costView"
          [propertiesLoaded]="costView.propertiesLoaded"
          (formulaChanged)="sendNrOfFormulas($event)"></component-formulas>
</div>
